import { render } from "./CreateQuiz.vue?vue&type=template&id=396bfda7&scoped=true"
import script from "./CreateQuiz.vue?vue&type=script&lang=js"
export * from "./CreateQuiz.vue?vue&type=script&lang=js"

import "./CreateQuiz.vue?vue&type=style&index=0&id=396bfda7&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396bfda7"]])

export default __exports__